export default "__VITE_ASSET__fHOKuyHS__"